// G1 Essential — theme JS
(function(){
  // Sticky header scrolled state
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => header.classList.toggle('scrolled', window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // Mobile menu toggle
  const toggle = document.querySelector('[data-mobile-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      menu.classList.toggle('open');
      const open = menu.classList.contains('open');
      toggle.setAttribute('aria-expanded', open);
      toggle.querySelector('[data-icon-menu]').classList.toggle('hidden', open);
      toggle.querySelector('[data-icon-close]').classList.toggle('hidden', !open);
    });
    menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => {
      menu.classList.remove('open');
    }));
  }

  // Reveal on scroll
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
  }, { rootMargin: '-60px' });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // Hydration tracker
  const tracker = document.querySelector('[data-hydration]');
  if (tracker) {
    const GOAL = 8;
    const KEY = 'tamra-hydration';
    const countEl = tracker.querySelector('[data-h-count]');
    const fillEl = tracker.querySelector('[data-h-fill]');
    const dots = tracker.querySelectorAll('[data-h-dot]');
    const doneBadge = tracker.querySelector('[data-h-done]');
    const undoBtn = tracker.querySelector('[data-h-undo]');
    const addBtn = tracker.querySelector('[data-h-add]');

    const todayKey = new Date().toDateString();
    let count = 0;
    try {
      const stored = JSON.parse(localStorage.getItem(KEY) || '{}');
      if (stored.date === todayKey) count = stored.count || 0;
    } catch {}

    const render = () => {
      countEl.textContent = count;
      fillEl.style.width = (count / GOAL * 100) + '%';
      dots.forEach((d, i) => {
        d.classList.toggle('filled', i < count);
      });
      doneBadge.classList.toggle('hidden', count < GOAL);
      undoBtn.disabled = count === 0;
      addBtn.disabled = count >= GOAL;
      localStorage.setItem(KEY, JSON.stringify({ date: todayKey, count }));
    };
    const update = (n) => { count = Math.max(0, Math.min(GOAL, n)); render(); };
    dots.forEach((d, i) => d.addEventListener('click', () => update(i < count ? i : i + 1)));
    undoBtn.addEventListener('click', () => update(count - 1));
    addBtn.addEventListener('click', () => update(count + 1));
    render();
  }

  // Newsletter client-side confirmation (if using a non-Shopify endpoint)
  document.querySelectorAll('[data-newsletter-js]').forEach(form => {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const wrap = form.closest('[data-newsletter]');
      if (wrap) {
        form.classList.add('hidden');
        wrap.querySelector('[data-newsletter-done]').classList.remove('hidden');
      }
    });
  });
})();
